import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from "../../services/menu.service";
import { MapService } from "../../services/map.service";
import * as mapboxgl from 'mapbox-gl';
import { LoggedUser } from "../../common/logged-user.service";
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {

  public readonly DEFAULT_ZOOM = 15;
  public readonly DEFAULT_LATITUDE = 39.98741;
  public readonly DEFAULT_LONGITUDE = -0.04506;

  public items: any[];
  public user: any;
  public tenantUuid: string;

  public map: mapboxgl.Map;

  private firstLevelChangeSubscription: Subscription;

  constructor(
    private menuService: MenuService,
    private mapService: MapService,
    protected loggedUser: LoggedUser
  ) { }

  ngOnInit(): void {
    this.loggedUser.userObservable.subscribe(user => {
      this.user = user;
      this.tenantUuid = user.tenantUuid;
      this.items = this.menuService.getItems().filter(item => item.routerLink !== '/');
    });
    this.firstLevelChangeSubscription = this.menuService.firstLevelChangeEmitter.subscribe((selected: MenuItem) => {
      this.scrollToElement(selected.routerLink);
    });
  }

  private scrollToElement(elementId: string) {
    let element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset -20;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  }

  ngOnDestroy(): void {
    this.firstLevelChangeSubscription.unsubscribe();
  }

}
